module.exports = __webpack_public_path__ + "img/1.ff9c4c12.png";